import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CoordinatorAddEditComponent } from './popups/coordinator-add-edit/coordinator-add-edit.component';
import { CoordinatorsService } from '../services/coordinators.service'
import { CoordinatorModel } from '../models/coordinator-model'
import { SharedService } from 'app/modules/common/services/shared-service';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms'
import { CurrenyService } from 'app/modules/common/services/curreny.service';
import Utils from 'app/Utils';

@Component({
    selector: 'app-coordinators-detail',
    templateUrl: './coordinators-detail.component.html',
    styleUrls: ['./coordinators-detail.component.scss'],
    standalone: false
})

export class CoordinatorsDetailComponent implements OnInit {
  public coordinatorsForm: UntypedFormGroup;
  @Input() nodeChangeGet: any;
  @Output() nodeUpdateTree = new EventEmitter();
  @Output() nodePanelHide = new EventEmitter();
  doctorName: string = '';
  fijoMes: number = 0;
  year: number = 0;
  despachosDataSource = [];

  permissionList: Array<string>;
  permit801: number;
  permit819: number;
  permit104: number;
  doctorInputFeilds: boolean = false;
  buttonDispaly: boolean = false;
  despachosInputFeilds: boolean = false;
  despachosInputActive: boolean = false;
  fijoMesShow:boolean =false;

  editarBtn: boolean = true;
  guardarBtn: boolean = false;
  cancelarBtn: boolean = false;
  eliminarBtn: boolean = true;
  fijoMesValue = '0';

  Coordinators: CoordinatorModel;

  constructor(
    private dialog: MatDialog,
    private _coordinatorsService: CoordinatorsService,
    private _sharedService: SharedService,
    private _currenyService: CurrenyService
  ) {
    this.Coordinators = new CoordinatorModel();

    this.coordinatorsForm = new UntypedFormGroup({
      doctorName: new UntypedFormControl(''),
      fijoMes: new UntypedFormControl(0, Validators.required),
    });

  }

  ngOnInit(): void {
    this.permissionList = Utils.decrypt(localStorage.getItem('permissionIds')).split(',');
    this.permit801 = this.permissionList.indexOf('801');
    this.permit819 = this.permissionList.indexOf('819');
    this.permit104 = this.permissionList.indexOf('104');

    if (this.permit104 != -1) {
      this.fijoMesShow = true;
    }
    if (this.permit801 != -1) {
      this.doctorInputFeilds = true;
      this.buttonDispaly = true;
    }
    if (this.permit819 != -1) {
      this.despachosInputFeilds = true;
    }
    this.year = (new Date()).getFullYear()

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.nodeChangeGet) {      
      this.LoadCoordinators(changes.nodeChangeGet.currentValue);
      this.Coordinators.CoordinadorId = this.nodeChangeGet.coordinadorId;
      this.year = (new Date()).getFullYear();
      this.LoadDispachos(this.nodeChangeGet.nombre, this.year)
      this.topButtonReset();
    }
  }

  LoadCoordinators(coordinador: any) {      
    this.coordinatorsForm.patchValue({
      doctorName: coordinador.nombre,
      fijoMes: coordinador.fijoMes ? this._currenyService.setSpanishCurreny(coordinador.fijoMes.toString()) : "0,00"
    });
    this.doctorName = coordinador.nombre;
    this.coordinatorsForm.disable();
  }

  LoadDispachos(Coordinador: any, Year: any) {
    this._coordinatorsService.GetDespachoC(Coordinador, Year).subscribe(res => {
      if (res) {
        this.despachosDataSource = res.result;
      }
    }, err => {
      console.error(err);
    })
  }

  onEdit() {
    this.despachosInputActive = true;
    this.guardarBtn = true;
    this.cancelarBtn = true;
    this.eliminarBtn = false;
    this.editarBtn = false;
    this.coordinatorsForm.enable();
  }

  onCancel() {
    this.topButtonReset()
    this.LoadCoordinators(this.nodeChangeGet);
    this.coordinatorsForm.disable();
  }

  onSave() {
    this.coordinatorsForm.markAllAsTouched();
    this.coordinatorsForm.updateValueAndValidity();
    if (this.coordinatorsForm.valid) {
      this.Coordinators.FijoMes = this._currenyService.replaceSpanishFormat(this.coordinatorsForm.get('fijoMes').value.toString());
      this.Coordinators.Nombre = this.coordinatorsForm.get('doctorName').value;
      this._coordinatorsService.UpdateCoordinators(this.Coordinators).subscribe(res => {
        if (res) {
          this._sharedService.ShowSnackBar('Actualizado correctamente', 'Okay', 2000);
          this.coordinatorsForm.disable();
          this.topButtonReset();
          this.nodeUpdateTree.emit(res.result)
        }
      }, err => {
        this._sharedService.ShowSnackBar('Error al actualizar', 'Okay', 2000);
        this.coordinatorsForm.disable();
        this.topButtonReset();
        console.error(err);
      })
    }
  }

  onDelete() {
    this.topButtonReset()
    const dialogData = new ConfirmDialogModel('¿Eliminar el coordinador?', "");
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this._coordinatorsService.DeleteSpecificCoordinators(this.nodeChangeGet.coordinadorId).subscribe(responce => {
          if (responce.result) {
            this.topButtonReset();
            this.resetInputs();
            this.LoadDispachos('', this.year)
            this.nodeUpdateTree.emit(responce.result)
            this.nodePanelHide.emit(false)
            this._sharedService.ShowSnackBar('Eliminado correctamente', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('Error al eliminar', 'Okay', 2000);
        })
      }
    });
  }

  onDeleteDrop(event) {
    const dialogData = new ConfirmDialogModel('¿Eliminar el despacho?', "");
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this._coordinatorsService.DeleteDespacho(event.id).subscribe(responce => {
          if (responce.result) {
            this.LoadDispachos(this.nodeChangeGet.nombre, this.year)
            this._sharedService.ShowSnackBar('Eliminado correctamente', 'Okay', 2000);
          }
        }, err => {
          console.error(err);
          this._sharedService.ShowSnackBar('Error al eliminar', 'Okay', 2000);
        })
      }
    });
  }

  yearMin() {
    this.year = this.year - 1;
    this.LoadDispachos(this.nodeChangeGet.nombre, this.year)
  }

  yearMax() {
    this.year = this.year + 1;
    this.LoadDispachos(this.nodeChangeGet.nombre, this.year)
  }

  public addEditCoordinator(data: any): void {
    const modalRef = this.dialog.open(CoordinatorAddEditComponent, {
      data: { isInsert: true, despachoId: 0, coordinador: this.nodeChangeGet.nombre }
    });
    modalRef.afterClosed().subscribe(res => {
      this.LoadDispachos(this.nodeChangeGet.nombre, this.year)
    });
  }

  public addEditCoordinatorDrop(dataModel: any): void {
    const modalRef = this.dialog.open(CoordinatorAddEditComponent, {
      data: { isInsert: false, coordinador: dataModel.coordinador, id: dataModel.id, realizada: dataModel.realizada, comentarios: dataModel.comentarios }
    });
    modalRef.afterClosed().subscribe(res => {
      this.LoadDispachos(this.nodeChangeGet.nombre, this.year)
    });
  }

  resetInputs() {
    this.doctorName = '';
    this.fijoMes = 0;
    this.despachosDataSource = [];
  }

  topButtonReset() {
    this.editarBtn = true;
    this.guardarBtn = false;
    this.cancelarBtn = false;
    this.eliminarBtn = true;
    this.despachosInputActive = false;
  }

}
